import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { JobArchitectureOptionsResponse } from '~/shared/data-contract/job-architecture';

import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { jobArchitectureKeys } from './query-keys';

export const useJobArchitectureOptions = (): UseQueryResult<JobArchitectureOptionsResponse, Error> => {
    const { fetchJobArchitectureOptions } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchJobArchitectureOptions();

            if (result.isOk === true) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: jobArchitectureKeys.options(),
        staleTime: 30_000,
        throwOnError: false,
    });
};
